import { Controller } from '@hotwired/stimulus'

const STORAGE_KEY = 'backoffice-sidebar-collapsed'

// Collapses the backoffice sidebar into an icon-only rail.
//
// This only sets state — the rail look is CSS, driven off the `data-collapsed` attribute this
// toggles on its element through `group-data-collapsed/sidebar:` variants. The choice persists in
// localStorage because Turbo visits re-render the whole body: connect() replays the stored state,
// so the sidebar stays collapsed across navigations.
//
// Targets:
//   toggle — the button that collapses/expands, mirrors the state on aria-expanded
export default class extends Controller {
  static targets = ['toggle']

  // Collapsed by default: only an explicit stored 'false' (the user expanded it) opens it, and
  // never below the md breakpoint, where every load starts collapsed.
  connect() {
    this.render(localStorage.getItem(STORAGE_KEY) !== 'false' || this.smallViewport, false)
  }

  toggle() {
    this.render(!this.collapsed)
  }

  // Bound on each section header: a click on a rail icon reopens the sidebar. The same click also
  // reaches disclosure#toggle, so the clicked section discloses at the same time.
  expand() {
    if (this.collapsed) this.render(false)
  }

  render(collapsed, persist = true) {
    this.element.toggleAttribute('data-collapsed', collapsed)
    this.toggleTarget.setAttribute('aria-expanded', String(!collapsed))
    if (persist) localStorage.setItem(STORAGE_KEY, String(collapsed))
  }

  get collapsed() {
    return this.element.hasAttribute('data-collapsed')
  }

  // Below Tailwind's md breakpoint (48rem) every page load starts collapsed — only the floating
  // button peeks from the edge — no matter what choice desktop stored.
  get smallViewport() {
    return window.matchMedia('(max-width: 767px)').matches
  }
}
